import React from 'react';
import { Box, Stack } from '@mui/material';
import NotificationsBox from './notificationsBox/notificationsBox';
import TodayAgenda from './todayAgenda/todayAgenda';
import Reminders from './reminder/reminder';

export default function HomeMobile() {
  return (
    <Box
      sx={{
        width: '100%',
        padding: '16px',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      <Stack spacing={2}>
        <TodayAgenda />

        <NotificationsBox />

        <Reminders />
      </Stack>
    </Box>
  );
}
